import { forwardRef as T, useRef as k, useCallback as i, useImperativeHandle as B } from "react";
import { useControl as H } from "react-map-gl";
import F from "@mapbox/mapbox-gl-draw";
import { generateDrawPolygonToolStyles as K } from "./index.es379.js";
import V from "./index.es380.js";
import j from "./index.es381.js";
import q from "./index.es382.js";
import z from "./index.es383.js";
import "./index.es4.js";
import "./index.es20.js";
import "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import { usePLMapboxStoreV2 as G } from "./index.es6.js";
import { usePLMapboxRefV2 as J } from "./index.es8.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import { createStore as N } from "zustand/vanilla";
const Q = {
  curDrawingMode: void 0,
  isDrawing: !1,
  selectedFeatureId: void 0
}, tr = T((r, x) => {
  const p = k(N()(() => Q)), m = J(r.mapId), e = H(
    () => new F({
      displayControlsDefault: !1,
      styles: K({
        inActiveTransparent: r.inActiveTransparent,
        polygonFillColor: r.polygonFillColor
      }),
      defaultMode: "pl_default_select",
      modes: {
        ...F.modes,
        pl_draw_polygon: V,
        pl_draw_line_string: j,
        pl_default_select: q,
        pl_direct_select: z
      }
    }),
    ({ map: t }) => {
      t.on("draw.modechange", M), t.on("draw.selectionchange", _), window.addEventListener("keydown", L);
    },
    ({ map: t }) => {
      t.off("draw.modechange", M), t.off("draw.selectionchange", _), window.removeEventListener("keydown", L), o("grab");
    }
  ), o = i(
    (t) => {
      G.getState().actions.setCursor({ mapId: r.mapId, cursor: t });
    },
    [r.mapId]
  ), a = i(() => {
    e.getSelectedIds().length > 0 && e.changeMode("pl_default_select"), p.current.setState({ selectedFeatureId: void 0 });
  }, [e]), s = i(
    (t) => {
      const c = e.getSelectedIds();
      (c.length === 0 || !new Set(c).has(t)) && e.changeMode("pl_direct_select", { featureId: t }), p.current.setState({ selectedFeatureId: t });
    },
    [e]
  ), u = i(() => e.getAll(), [e]), P = i(
    (t) => {
      e.delete([t]);
    },
    [e]
  ), y = i(() => {
    a(), p.current.setState({ isDrawing: !0, curDrawingMode: "Polygon" }), e.changeMode("pl_draw_polygon"), o("crosshair"), r.onDrawPolygon && r.onDrawPolygon();
  }, [a, e, r, o]), h = i(() => {
    a(), p.current.setState({ isDrawing: !0, curDrawingMode: "LineString" }), e.changeMode("pl_draw_line_string"), o("crosshair"), r.onDrawLine && r.onDrawLine();
  }, [a, e, r, o]), d = i(
    (t) => {
      p.current.setState({ isDrawing: !1, curDrawingMode: void 0 }), e.trash(), a(), o("grab"), t && e.delete(t), r.onCancel && r.onCancel();
    },
    [a, e, r, o]
  ), D = i(
    ({
      polygonVisible: t = !0,
      polygonFillVisible: c,
      polygonFillColor: S,
      polygonFillOpacity: g,
      polygonStrokeVisible: E,
      polygonStrokeColor: v,
      polygonStrokeOpacity: w,
      polygonStrokeWidth: I,
      lineVisible: R = !0,
      lineStrokeVisible: A,
      lineStrokeColor: C,
      lineStrokeOpacity: f,
      lineStrokeWidth: b
    }) => {
      ["gl-draw-polygon-fill.cold", "gl-draw-polygon-fill.hot"].forEach((n) => {
        const l = t && c && g ? g / 100 : 0;
        S && m.getMap().setPaintProperty(n, "fill-color", S), g && m.getMap().setPaintProperty(n, "fill-opacity", l);
      }), [
        "gl-draw-polygon-stroke.cold",
        "gl-draw-polygon-stroke.hot",
        "gl-draw-line-draw-polygon-mode.cold",
        "gl-draw-line-draw-polygon-mode.hot"
      ].forEach((n) => {
        const l = t && E && w ? w / 100 : 0;
        v && m.getMap().setPaintProperty(n, "line-color", v), I && m.getMap().setPaintProperty(n, "line-width", I), w && m.getMap().setPaintProperty(n, "line-opacity", l);
      }), ["gl-draw-line.cold", "gl-draw-line.hot"].forEach((n) => {
        const l = R && A && f ? f / 100 : 0;
        C && m.getMap().setPaintProperty(n, "line-color", C), b && m.getMap().setPaintProperty(n, "line-width", b), f && m.getMap().setPaintProperty(n, "line-opacity", l);
      });
    },
    [m]
  ), M = i(
    (t) => {
      (/* @__PURE__ */ new Set(["pl_draw_polygon", "pl_draw_line_string"])).has(t.mode) || (p.current.setState({ isDrawing: !1, curDrawingMode: void 0 }), o("grab"));
    },
    [o]
  ), _ = i(
    (t) => {
      if (t.features.length === 0) {
        a();
        return;
      }
      if (t.features.length > 0) {
        s(t.features[0].id);
        return;
      }
    },
    [a, s]
  ), L = (t) => {
    t.key === "Escape" && p.current.getState().isDrawing && d();
  };
  return B(
    x,
    () => ({
      mapboxDraw: e,
      state: p.current,
      setPLMapboxCursor: o,
      clearSelectedFeatures: a,
      selectFeatureById: s,
      getAllFeatures: u,
      deleteFeatureById: P,
      drawPolygon: y,
      drawLine: h,
      cancel: d,
      updateStyle: D
    }),
    [
      d,
      a,
      P,
      h,
      y,
      u,
      e,
      s,
      o,
      D
    ]
  ), null;
});
export {
  tr as PLDrawControl,
  Q as initialPLDrawState
};
//# sourceMappingURL=index.es166.js.map
